import { render, staticRenderFns } from "./CoursewareGalleryBlock.vue?vue&type=template&id=a56f8302&scoped=true&"
import script from "./CoursewareGalleryBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareGalleryBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareGalleryBlock.vue?vue&type=style&index=0&id=a56f8302&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56f8302",
  null
  
)

export default component.exports